module.exports = __webpack_public_path__ + "static/media/img104.c181fc73.jpg";